var videos = document.getElementsByClassName('wp-block-video');

for (let i = 0; i < videos.length; i++) {
	let video = videos[i];
	video.style.setProperty('--vid-color', '#0C2652');

	video.addEventListener('click', () => {
		var currentColor = video.style.getPropertyValue('--vid-color');
		if (currentColor != 'transparent') {
			video.style.setProperty('--vid-color', 'transparent');
			video.style.setProperty('--vid-play', 'none');
		} else {
			video.style.setProperty('--vid-color', '#0C2652');
			video.style.setProperty('--vid-play', 'block');
		}

	})
}
